import React from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './HomeSlider.css';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';
import { injectIntl } from 'react-intl';

// Component
import HomeItem from '../HomeItem';
import Loader from '../../Loader';


//Helper
import { isRTL } from '../../../helpers/formatLocale';

// Graphql
import getRecommendQuery from '../../../routes/home/getRecommend.graphql';

//Images
import NearByImage from '../../../../public/SiteImages/nearbyOffice.png';

class SlideComponent extends React.Component {

  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.shape({
      listPhotos: PropTypes.arrayOf(PropTypes.shape({
        name: PropTypes.string
      })),
      coverPhoto: PropTypes.number,
      listingData: PropTypes.shape({
        basePrice: PropTypes.number,
        currency: PropTypes.string,
      }),
      settingsData: PropTypes.arrayOf(PropTypes.shape({
        listsettings: PropTypes.shape({
          itemName: PropTypes.string,
        }),
      })),
      id: PropTypes.number,
      beds: PropTypes.number,
      title: PropTypes.string,
      bookingType: PropTypes.string,
      reviewsCount: PropTypes.number,
      reviewsStarRating: PropTypes.number
    }))
  };

  static defaultProps = {
    data: [],
    arrow: true
  }

  constructor(props) {
    super(props);
    this.state = {
      load: false
    };
  }

  componentDidMount() {
    this.setState({
      load: true
    });
  }

  UNSAFE_componentWillReceiveProps(prevProps) {
    const { locale } = this.props.intl;
    const { locale: prevLocale } = prevProps.intl;
    if (locale !== prevLocale) {
      this.setState({
        load: false
      });
      clearTimeout(this.loadSync);
      this.loadSync = null;
      this.loadSync = setTimeout(() => {
        this.setState({
          load: true
        })
      }, 1);
    }
  }

  render() {
    const { intl: { locale }, getRecommendData } = this.props;
    const { load } = this.state;
    let data, loading, items;
    data = getRecommendData.getRecommend;
    loading = getRecommendData.loading;
    items = data && data.filter((item, index) => index < 5) || [];
    if(!load || loading) return <Loader type="text" />
    return (
      <Grid fluid>
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className={cx('noPadding')}>
            {
              (load || !loading) && <div rtl={isRTL(locale).toString()} className={s.displayGrid}>
                {
                  items && items.length > 0 && items.map((item, index) => {
                    if (item && item.listPhotos && item.listPhotos.length > 0) {
                      return (
                        <div className={cx(s.oddClass)} key={index}>
                            <HomeItem
                              id={item.id}
                              title={item.title}
                              basePrice={item.listingData.basePrice}
                              currency={item.listingData.currency}
                              roomType={item.settingsData[0].listsettings.itemName}
                              beds={item.beds}
                              listPhotos={item.listPhotos}
                              coverPhoto={item.coverPhoto}
                              photo={item.listPhotos[0].name}
                              bookingType={item.bookingType}
                              reviewsCount={item.reviewsCount}
                              reviewsStarRating={item.reviewsStarRating}
                              wishListStatus={item.wishListStatus}
                              isListOwner={item.isListOwner}
                              userId={item && item.user && item.user.id}
                              city={item.city}
                              userAmenities={item.userAmenities}
                              personCapacity={item.personCapacity}
                              isSample={item.isSample}
                              taxRate={item.listingData.taxRate}
                            />
                        </div>
                      )
                    }
                  })
                }
                {
                   (load || !loading) && <div>
                   <div className={s.nearByBgSection}>
                     <div className={s.nearByBg} style={{ backgroundImage: `url(${NearByImage})` }} />
                     <div className={cx(s.positionRelative, s.nearByTextSection)}>
                       <h3 className={s.nearbyTitle}>Do you want to explore more nearby offices?</h3>
                       <a className={s.btn} href={'/s'} >Show more</a>
                     </div>
                   </div>
                 </div>
                }
              </div>
            }
          </Col>
        </Row>
      </Grid>
    );
  }
};


export default compose(
	injectIntl,
	withStyles(s),
    graphql(getRecommendQuery, {
      name: 'getRecommendData',
      options: {
        ssr: false
      }
    }),
)(SlideComponent);


// WEBPACK FOOTER //
// src/components/Home/HomeSlider/HomeSlider.js